import type { Role } from '../../typings/api';
import { RoleScope } from '../../typings/enums';
import type { SelectOption } from '../types';
import { selectOptionFactory } from '../utils';

export const roleLabel = (roles: { [key in number | string]: { name: string } }, roleId: number | null): string => {
  if (!roleId) {
    return 'None'; // null is not a number
  }

  return roles[roleId]?.name || 'None';
};

type RolesList = Array<{ id: number | null; name: string }>;

export const orgRolesList = (roles: { [key in number | string]: Role }): RolesList => {
  const list: RolesList = Object.values(roles)
    .filter(role => role.scope === RoleScope.Organization)
    .sort((a, b) => a.name.localeCompare(b.name));

  list.push({
    id: null,
    name: 'None',
  });

  return list;
};

// roleOptions returns an array of SelectOption objects to be used in a selector component.
export const roleOptions = (
  roles: { [key in number | string]: Role },
  scope: RoleScope,
): Array<SelectOption<number>> =>
  Object.values(roles)
    .filter(role => role.scope === scope)
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(role => selectOptionFactory(role.id, role.name));
